import React from "react";
import PropTypes from "prop-types";
import { LiveAnnouncer } from "react-aria-live";
import FederatedSolrComponentPack from "./federated_solr_component_pack";
import helpers from "../helpers";
import reactT from "./reactT";
import customPending from "./results/customPending"
//import componentPack from "./component-pack";

const getFacetValues = (type, results, field, lowerBound, upperBound) => {
  return type === "period-range-facet"
    ? (results.facets[lowerBound] || []).concat(
        results.facets[upperBound] || []
      )
    : type === "list-facet" || type === "range-facet"
    ? results.facets[field] || []
    : null;
};
class FederatedSolrFacetedSearch extends React.Component {
  constructor(props) {
    super(props);

    this.resetFilters = this.resetFilters.bind(this);
  }

  resetFilters(e) {
    e.preventDefault();
    let { query } = this.props;
    const urlParams = new URLSearchParams(window.location.search);
    let searchTerm = "";
    // Keep only the value of the main search field.
    for (const field of query.searchFields) {
      if (field.field !== query.mainQueryField && field.field !== 'ss_search_api_language') {
        // Remove the field value.
        delete field.value;
        // Collapse the sidebar filter toggle.
        field.collapse = true;
        // Collapse the terms sidebar filter toggle.
        if (Object.hasOwnProperty.call(field, "expandedHierarchies")) {
          field.expandedHierarchies = [];
        }
      } else if (field.field === query.mainQueryField) {
        // Extract the value of the main search term to use when setting new URL for this state.
        searchTerm = field.value;
      }
    }
    // Set new parsed params based on only search term value.
    const parsed = {
      keywords: searchTerm,
      sort: urlParams.get('sort'),
      order: urlParams.get('order'),
    };
    // Add new url to browser window history.
    helpers.qs.addNewUrlToBrowserHistory(parsed);

    // Update state to remove the filter field values.
    this.setState({ query });
    // Execute search.
    this.props.onSearchFieldChange();
  }

  render() {
    const {
      customComponents,
      bootstrapCss,
      query,
      results,
      truncateFacetListsAt,
      options,
      onSearchFieldChange,
      onTextInputChange,
      onSortFieldChange,
      onToggleSwitchChange,
      onPageChange,
    } = this.props;
    const { searchFields, sortFields, rows } = query;
    const start = query.start ? query.start : 0;
    const SearchFieldContainerComponent =
      customComponents.searchFields.container;
    const ResultContainerComponent = customComponents.results.container;
    const CurrentQueryComponent = customComponents.searchFields.currentQuery;
    const ResultComponent = customComponents.results.result;
    const ResultCount = customComponents.results.resultCount;
    const ResultHeaderComponent = customComponents.results.header;
    const ResultListComponent = customComponents.results.list;
    const ResultPendingComponent = customPending;
    const PaginateComponent = customComponents.results.paginate;
    const PreloadComponent = customComponents.results.preloadIndicator;
    const SortComponent = customComponents.sortFields.menu;
    const ToggleSwitch = customComponents.switch.switcher;
    const FederatedTextSearch = FederatedSolrComponentPack.searchFields.text;

    let CurrentFacetsCounter = 0;
    searchFields.forEach(searchField => {
      const currentUrl = window.location.href;
      const currentUrlLength = currentUrl.length;

      // Check if the URL length exceeds 2000 characters
      if (currentUrlLength > 2000) {
        CurrentFacetsCounter = 11;
      }
    });

    const resultPending = results.pending
        ? (<ResultPendingComponent bootstrapCss={bootstrapCss} />)
        : null;

    const pagination =
      query.pageStrategy === "paginate" ? (
        <PaginateComponent
          {...this.props}
          bootstrapCss={bootstrapCss}
          onChange={onPageChange}
        />
      ) : null;

    const preloadListItem =
      query.pageStrategy === "cursor" &&
      results.docs.length < results.numFound ? (
        <PreloadComponent {...this.props} />
      ) : null;

    let pageTitle;
    if (this.props.options.pageTitle != null) {
      pageTitle = <h1>{this.props.options.pageTitle}</h1>;
    }

    return (
      <LiveAnnouncer>
        <div className="vlb-section columns-separator mb-0">
          <div className="facet-filter-wrapper layout row layout-builder__layout">
            <div className="col-lg-3 col-md-4 col-sm-12 col-12 order-md-0 mb-0">
            <div className="view-display-id-search_result_block d-md-none unhcr-search pt-2 pb-0">
                {pageTitle}
                <div className="view-filters">
                  <form className="views-exposed-form" autoComplete="off" onSubmit={(e)=>e.preventDefault()}>
                    <div className="form-row">
                      <FederatedTextSearch
                        {...this.props}
                        autocomplete={options.autocomplete}
                        field={
                          searchFields.find((sf) => sf.id === "textSearchField")
                            .field
                        }
                        label=""
                        onSuggest={onTextInputChange}
                        onChange={onSearchFieldChange}
                        value={
                          searchFields.find((sf) => sf.id === "textSearchField")
                            .value
                        }
                      />
                    </div>
                  </form>
                </div>
                <p
                  className={
                    searchFields.find((sf) => sf.id === "textSearchField")
                      .value || this.props.options.showEmptySearchResults
                      ? "solr-search-results-container__prompt element-invisible"
                      : "solr-search-results-container__prompt"
                  }
                >
                  {this.props.options.searchPrompt ||
                    "Please enter a search term."}
                </p>
              </div>
              <div className="search-filters-wrapper">
                <div className="container-sm d-flex d-md-block justify-content-between align-items-center flex-wrap p-md-0">
              <SortComponent
                bootstrapCss={bootstrapCss}
                onChange={onSortFieldChange}
                sortFields={sortFields}
              />
              <SearchFieldContainerComponent
                {...this.props}
                bootstrapCss={bootstrapCss}
                onNewSearch={this.resetFilters}
                resultsCount={this.props.results.numFound}
                CurrentFacetsCounter={CurrentFacetsCounter}
              >
                <ToggleSwitch
                  title={reactT("Search in full text")}
                  name="fulltext-filter"
                  id="search-in-fulltext"
                  onChange={onToggleSwitchChange}
                  defaultChecked={true}
                />
                {/* Only render the visible facets / filters.
                  Note: their values may still be used in the query, if they were pre-set. */}
                <div className="search-facets">
                {CurrentFacetsCounter >= 10 ? <div className="alert alert-warning z-index-6 w-100 hint-message unlimited-message" role="alert">{reactT('You have selected the maximum number of filters for this search. Please deselect one or more filters to continue.')}</div> :''}
                {searchFields
                  .filter(
                    (searchField) =>
                      this.props.sidebarFilters.indexOf(searchField.field) >
                        -1 && !searchField.isHidden
                  )
                  .map((searchField, i) => {
                    const { type, field, lowerBound, upperBound } = searchField;
                    const SearchComponent = customComponents.searchFields[type];
                    const facets = getFacetValues(
                      type,
                      results,
                      field,
                      lowerBound,
                      upperBound
                    );

                    return (
                      <SearchComponent
                        key={i}
                        {...this.props}
                        {...searchField}
                        bootstrapCss={bootstrapCss}
                        facets={facets}
                        truncateFacetListsAt={truncateFacetListsAt}
                        onChange={onSearchFieldChange}
                        CurrentFacetsCounter={CurrentFacetsCounter}
                        className={i === 0 ? 'mt-0' : ''}
                      />
                    );
                  })}
                </div>
              </SearchFieldContainerComponent>
              <CurrentQueryComponent
                  {...this.props}
                  onChange={onSearchFieldChange}
                />
              </div>
              </div>

            </div>
            <div className="col-lg-9 col-md-8 col-sm-12 col-12 order-md-0 unhcr-search">
              <div className="view-display-id-search_result_block">
                {pageTitle}
                <ResultCount
                  pending = {results.pending}
                  bootstrapCss={bootstrapCss}
                  numFound={results.numFound}
                  start={start}
                  rows={rows}
                  onChange={onPageChange}
                  noResultsText={this.props.options.noResults || null}
                  termValue={
                    searchFields.find((sf) => sf.id === "textSearchField").value
                  }
                  className="d-none d-md-block"
                />
                <div className="view-filters d-none d-md-block">
                  <form className="views-exposed-form" autoComplete="off" onSubmit={(e)=>e.preventDefault()}>
                    <div className="form-row">
                      <FederatedTextSearch
                        {...this.props}
                        autocomplete={options.autocomplete}
                        field={
                          searchFields.find((sf) => sf.id === "textSearchField")
                            .field
                        }
                        label=""
                        onSuggest={onTextInputChange}
                        onChange={onSearchFieldChange}
                        value={
                          searchFields.find((sf) => sf.id === "textSearchField")
                            .value
                        }
                      />
                    </div>
                  </form>
                </div>
                <p
                  className={
                    searchFields.find((sf) => sf.id === "textSearchField")
                      .value || this.props.options.showEmptySearchResults
                      ? "solr-search-results-container__prompt element-invisible"
                      : "solr-search-results-container__prompt"
                  }
                >
                  {this.props.options.searchPrompt ||
                    "Please enter a search term."}
                </p>
                <div
                  className={
                    searchFields.find((sf) => sf.id === "textSearchField")
                      .value || this.props.options.showEmptySearchResults
                      ? "solr-search-results-container__wrapper"
                      : "solr-search-results-container__wrapper element-invisible"
                  }
                >
                  <ResultContainerComponent bootstrapCss={bootstrapCss}>
                    <ResultHeaderComponent bootstrapCss={bootstrapCss}>
                      {resultPending}
                    </ResultHeaderComponent>
                    <ResultListComponent bootstrapCss={bootstrapCss}>
                      {results.docs.map((doc, i) => (
                        <ResultComponent
                          bootstrapCss={bootstrapCss}
                          doc={doc}
                          fields={searchFields}
                          key={doc.id || i}
                          onSelect={this.props.onSelectDoc}
                          resultIndex={i}
                          rows={rows}
                          start={start}
                          highlight={results.highlighting[doc.id]}
                          hostname={this.props.options.hostname}
                        />
                      ))}
                      {preloadListItem}
                    </ResultListComponent>
                    {pagination}
                  </ResultContainerComponent>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LiveAnnouncer>
    );
  }
}

FederatedSolrFacetedSearch.defaultProps = {
  bootstrapCss: true,
  customComponents: FederatedSolrComponentPack,
  pageStrategy: "paginate",
  rows: 10,
  searchFields: [
    {
      type: "text",
      field: "*",
    },
  ],
  sortFields: [],
  truncateFacetListsAt: -1,
  showCsvExport: false,
  sidebarFilters: [
    "sm_site_name",
    "sm_keywords_name",
    "ds_created",
    "ss_type",
    "sm_country_name",
    "ss_document_type_name",
    "sm_region_name",
  ],
  options: {},
};

FederatedSolrFacetedSearch.propTypes = {
  bootstrapCss: PropTypes.bool,
  customComponents: PropTypes.object,
  onCsvExport: PropTypes.func,
  onNewSearch: PropTypes.func,
  onPageChange: PropTypes.func,
  onSearchFieldChange: PropTypes.func.isRequired,
  onTextInputChange: PropTypes.func,
  onSelectDoc: PropTypes.func,
  onSortFieldChange: PropTypes.func.isRequired,
  onToggleSwitchChange: PropTypes.func.isRequired,
  query: PropTypes.object,
  results: PropTypes.object,
  showCsvExport: PropTypes.bool,
  truncateFacetListsAt: PropTypes.number,
  options: PropTypes.object,
};

export default FederatedSolrFacetedSearch;
